
import {clickPageAbuotEnterprise} from "@/api/method"

export default {
    visitCompanyPage(context,data){
        return  new Promise((resolve, reject)=>{
          clickPageAbuotEnterprise({
              terminal:5,
              ...data
            }).then(res => {
            if (res.data.code == 0) {
              resolve(res)
            } else {
              reject('接口请求失败')
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
}



// WEBPACK FOOTER //
// ./src/store/actions.js